"use client";

import { c as _c } from "react/compiler-runtime";
interface Props {
  readonly text: string;
  readonly className?: string | undefined;
  readonly align?: "left" | "center" | undefined;
}
export default function CollectionCardMetricLine(t0) {
  const $ = _c(21);
  const {
    text,
    className: t1,
    align: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const align = t2 === undefined ? "left" : t2;
  const separatorIndex = text.indexOf(":");
  const textAlignClass = align === "center" ? "tw-text-center" : "tw-text-left";
  const baseClass = `tw-mt-2 tw-w-full ${textAlignClass} tw-text-xs tw-leading-5`;
  if (separatorIndex === -1) {
    const t3 = `${baseClass} tw-text-iron-500 ${className}`;
    let t4;
    if ($[0] !== t3) {
      t4 = t3.trim();
      $[0] = t3;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== t4 || $[3] !== text) {
      t5 = <div className={t4}>{text}</div>;
      $[2] = t4;
      $[3] = text;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    return t5;
  }
  let t3;
  if ($[5] !== separatorIndex || $[6] !== text) {
    t3 = text.slice(0, separatorIndex + 1);
    $[5] = separatorIndex;
    $[6] = text;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const label = t3;
  let t4;
  if ($[8] !== separatorIndex || $[9] !== text) {
    t4 = text.slice(separatorIndex + 1).trimStart();
    $[8] = separatorIndex;
    $[9] = text;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const value = t4;
  const t5 = `${baseClass} ${className}`;
  let t6;
  if ($[11] !== t5) {
    t6 = t5.trim();
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== label) {
    t7 = <span className="tw-text-iron-500">{label} </span>;
    $[13] = label;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== value) {
    t8 = <span className="tw-font-semibold tw-text-iron-200">{value}</span>;
    $[15] = value;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}